import { useState } from "react";
import { Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { act } from "@/lib/hooks";
import { api, fdatetime } from "@/lib/api";
import { Section, StatusBadge } from "@/components/common";

const EMAIL = { sent: ["success", "emailed"], skipped_demo_address: ["neutral", "demo address, not emailed"], failed: ["danger", "email failed"], no_requester_email: ["neutral", "no email on file"] };

export function TicketThread({ url, data, reload, canReply, mine, hint, note }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => { setBusy(true); if (await act(() => api.post(url, { text }), "Message sent")) { setText(""); reload(); } setBusy(false); };
  const msgs = data?.messages || [];
  return (
    <Section title="Messages" testId="ticket-thread">
      <ul className="divide-y divide-slate-100" data-testid="ticket-thread-list">
        {msgs.length === 0 && <li className="px-5 py-4 text-sm text-slate-400" data-testid="ticket-thread-empty">No messages yet.</li>}
        {msgs.map((m, i) => (
          <li key={m.id || i} className={`px-5 py-3 text-sm ${m.side === mine ? "" : "bg-slate-50/70"}`} data-testid={`thread-msg-${m.side}`}>
            <div className="flex flex-wrap items-center gap-2 text-xs text-slate-500">
              <span className="font-semibold text-slate-800" data-testid="thread-msg-sender">{m.by}</span>
              <StatusBadge tone={m.side === "support" ? "info" : "neutral"} label={m.role_label} className="!normal-case" />
              {m.channel === "email" && <span>via email</span>}
              {note && m.side === "support" && EMAIL[m.email_status] && <StatusBadge tone={EMAIL[m.email_status][0]} label={EMAIL[m.email_status][1]} className="!normal-case" />}
              <span data-testid="thread-msg-time">· {fdatetime(m.at)}</span>
            </div>
            <p className="mt-1 whitespace-pre-wrap text-slate-700" data-testid="thread-msg-text">{m.text}</p>
          </li>))}
      </ul>
      {canReply ? (
        <div className="space-y-2 border-t p-5" style={{ borderColor: "var(--po-border)" }}>
          <Textarea data-testid="ticket-thread-input" rows={3} value={text} onChange={(e) => setText(e.target.value)} placeholder="Write a message…" />
          <div className="flex flex-wrap items-center justify-between gap-2"><span className="text-xs text-slate-500">{hint}</span>
            <Button data-testid="ticket-thread-send" disabled={busy || !text.trim()} onClick={send} className="bg-[#13294B] hover:bg-[#1c3a66]"><Send className="mr-1 h-4 w-4" />Send</Button></div>
        </div>) : data && <p className="border-t px-5 py-3 text-xs text-slate-500" style={{ borderColor: "var(--po-border)" }} data-testid="ticket-thread-closed">Replies are closed for this ticket. Reopen it to send a message.</p>}
    </Section>);
}
